// extracted by mini-css-extract-plugin
export default {"home-image":"ASxTHzYBQtMkIOmbCNhG"};